import { render, staticRenderFns } from "./step7lekarstva.vue?vue&type=template&id=0d3990c7&scoped=true"
import script from "./step7lekarstva.vue?vue&type=script&lang=js"
export * from "./step7lekarstva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3990c7",
  null
  
)

export default component.exports